import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Homepage from './components/Homepage';
import NotFoundPage from './common/NotFoundPage';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import DeliveryFormWrapper from './context/wrappers/DeliveryFormWrapper';


const router = createBrowserRouter([
    {
        path: '/:type?',
        element: <Homepage />,
        errorElement: <NotFoundPage />,
    },
    {
        path: '/service/:type',
        element: <DeliveryFormWrapper />,
        errorElement: <NotFoundPage />,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<RouterProvider router={router} />);

